import { h, render } from 'preact';
import 'preact/debug';

import { preactWidget } from '../../utils';

import { LoginBarContainerComponent } from './component';
import widget from './widget';

export const hydrate = () => {
  const { $root, props } = preactWidget(widget);
  render(<LoginBarContainerComponent htmlProps={props.htmlProps} widget={widget} $root={$root} />, $root);
};
